import type { IconData } from '@stacksjs/iconify-core'

export const thermometerFlat: IconData = {
  "body": "<g fill=\"none\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path fill=\"#8fbffa\" d=\"M23.402 1.505a38 38 0 0 1 1.195 0c2.297.036 4.204.982 5.54 2.523c1.317 1.518 2.02 3.538 2.118 5.682c.134 2.951.244 7.223.244 13.29q0 .944-.003 1.832A12.47 12.47 0 0 1 36.499 34c0 6.904-5.596 12.5-12.5 12.5c-6.903 0-12.5-5.596-12.5-12.5a12.47 12.47 0 0 1 4.004-9.168q-.004-.887-.004-1.832c0-6.067.111-10.339.245-13.29c.098-2.144.801-4.164 2.117-5.682c1.337-1.54 3.244-2.487 5.541-2.523\"/><path fill=\"#2859c5\" d=\"M26 29.968V10a2 2 0 1 0-4 0v19.968a4.5 4.5 0 1 0 4 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default thermometerFlat
